import { Middleware } from "@reduxjs/toolkit";
import { identifyUser, clearUserIdentification } from "./userbackClient";
import { authApi } from "../authentication/authApi";
import { oAuthApi } from "../authentication/oAuthApi";
import { logout } from "../authentication/authSlice";

export const userbackMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (logout.match(action)) {
    clearUserIdentification();
  } else if (authApi.endpoints.login.matchFulfilled(action)) {
    const email = action.payload.data.email;
    const displayName = action.payload.data.displayName;
    if (email || displayName) {
      identifyUser(email || displayName || "anonymous", {
        name: email || "",
        email: email || "",
      });
    }
  } else if (oAuthApi.endpoints.submitGoogleResponse.matchFulfilled(action)) {
    const email = action.payload.data.email;
    const displayName = action.payload.data.displayName;
    if (email || displayName) {
      identifyUser(email || displayName || "anonymous", {
        name: email || "",
        email: email || "",
      });
    }
  }

  return result;
};

